<div class="formHeader">
  Manage Multi-Factor Authentication (MFA) on your Identify login
</div>

<form class="formFieldList" [formGroup]="form" style="width:100%;">

  <ng-container *ngIf="loggedInDirectly">
    <ng-container *ngIf="mfaEnabled">
      <div style="display: flex; align-items: flex-start; justify-content: space-between;">
        <div>
        <div>MFA (using an authenticator app) is currently enabled for your login</div>
        <div style="padding-top: 10px;">Please note that this only applies when logging in using direct email address login. It does not apply to any SSO logins. MFA for SSO credentials must be configured with your SSO provider.</div> 
        </div>
        <button mat-button type="button" color="primary" style="flex-shrink:0" (click)="disableMfa()">Disable MFA</button>
      </div>
    </ng-container>

    <ng-container *ngIf="mfaEnabled === false">
      <div style="display: flex; align-items: flex-start; justify-content: space-between;">
        <div>
        <div>MFA is currently <font class="text-warn">disabled</font> for your login</div>
        <div style="padding-top: 10px;">Enabling MFA will only apply when logging in using your direct email address login. It will not apply to any SSO logins. MFA for SSO credentials must be configured with your SSO provider.</div> 
        </div>
        <button [disabled]="mfaQrUri != undefined" mat-button type="button" color="primary" style="flex-shrink:0" (click)="getMfaSecret()">Enable MFA</button>
      </div>

      <ng-container *ngIf="mfaQrUri">
        <div style="display: flex; flex-direction: column;">
          <h3 class="text-primary">Step 1: Scan this barcode with your authenticator app</h3>
          <div style="align-self:center;" class="qr-container mat-elevation-z1"><qr-code [value]="mfaQrUri" [size]="150"></qr-code></div>
          <div style="padding-top: 20px;">If you can't use a barcode, you can enter this code instead:</div>
          <div style="padding-bottom: 20px; align-self:center" class="text-accent">{{mfaSecret}}</div>
        </div>
        <div style="display: flex; flex-direction: column;">
          <h3 class="text-primary">Step 2: Enter the code from your authenticator app</h3>
          <div style="display: flex; flex-direction: row;">
          <mat-form-field style="flex-grow:1">
            <mat-label>6 digit code (no spaces)</mat-label>
            <input matInput placeholder="e.x. 123456" formControlName="totpCode" required minlength="6" maxlength="6">
            <mat-icon *ngIf="totpVerified" style="color:green" matPrefix>check</mat-icon>
            <mat-error *ngIf="form?.controls?.totpCode.hasError('invalidTotp')">The authenticator code could not be verified</mat-error>
          </mat-form-field>
          <button [disabled]="!form.dirty || !form.valid" mat-button color="primary" (click)="verifyTotpToken()">Verify MFA Token</button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div *ngIf="!loggedInDirectly">
    You must be logged in with your Identify username to update MFA settings.
  </div>
</form>
